import Core6Utilities from './Core6Utilities';
import Core6BlockDragger from '../core6_dragger/Core6BlockDragger';

export default class Core6PagedSlider {
  static initPagedSliders() {
    Core6PagedSlider.showPagedSliderBlockNumbers();
    Core6PagedSlider.showSlide(0);
  }

  static disableNewPagedSlidersIfNeeded() {
    const allPagedSliders = Core6PagedSlider.getAllPagedSliders();
    if (allPagedSliders.length > 0) {
      const allPagedSliderSelectors = Core6Utilities.getJQueryElement('option[value="pagedsliderblock"]');
      allPagedSliderSelectors.html('Paged Slider (only one per page)');
      allPagedSliderSelectors.attr('disabled', true);
    }
  }

  static getLastIndex() {
    const allPagedSliders = Core6PagedSlider.getAllPagedSliders();
    return allPagedSliders.length - 1;
  }

  static getCurrentSlide() {
    return Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock:visible');
  }

  static getAllPagedSliders() {
    return Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock');
  }

  static getFirstPagedSlider() {
    const allPagedSliders = Core6PagedSlider.getAllPagedSliders();
    const sliderCount = allPagedSliders.length;

    for (let i = 0; i < sliderCount; i += 1) {
      return $(allPagedSliders[i]);
    }
    return false;
  }

  static getCurrentSlideIndex() {
    const allPagedSliders = Core6PagedSlider.getAllPagedSliders();
    const currentSlide = Core6Utilities.getJQueryElement('.core6-mainrow-container.pagedsliderblock:visible');

    const sliderCount = allPagedSliders.length;
    for (let i = 0; i < sliderCount; i += 1) {
      const thisSlide = $(allPagedSliders[i]);
      if (thisSlide.attr('data-row-id') === currentSlide.attr('data-row-id')) {
        console.log(`returning slide ${i} as the selected slide`);
        return i;
      }
    }
    return false;
  }

  static showPagedSliderBlockNumbers() {
    const allPagedSliders = Core6PagedSlider.getAllPagedSliders();

    const sliderCount = allPagedSliders.length;
    for (let i = 0; i < sliderCount; i += 1) {
      const thisSlide = $(allPagedSliders[i]);
      const sliderPagingTemplate = thisSlide.find('.sliderPagingTemplate').clone();
      const selectedSliderPagingTemplate = thisSlide.find('.sliderPagingTemplate').clone();
      const sliderPagingContainer = thisSlide.find('.sliderPagingContainer');

      $(selectedSliderPagingTemplate).find('li').addClass('selectedSlide');

      let newPagingHTML = '';
      for (let x = 0; x < sliderCount; x += 1) {
        const readableNumber = x + 1;
        $(sliderPagingTemplate).find('a').attr('data-core6-param', x);
        $(selectedSliderPagingTemplate).find('a').attr('data-core6-param', x);

        $(sliderPagingTemplate).find('a').html(readableNumber);
        $(selectedSliderPagingTemplate).find('a').html(readableNumber);

        if (x === i) {
          if (i > 0) {
            const previous = selectedSliderPagingTemplate.clone();
            $(previous).find('a').attr('data-core6-action', 'nudgePagedSliderPrevious');
            $(previous).find('a').html('&lt;');
            $(previous).find('a').css('background-color', '#ff0000');
            newPagingHTML += previous.html();
          }

          newPagingHTML += selectedSliderPagingTemplate.html();

          if (i < (sliderCount - 1)) {
            const next = selectedSliderPagingTemplate.clone();
            $(next).find('a').attr('data-core6-action', 'nudgePagedSliderNext');
            $(next).find('a').html('&gt;');
            $(next).find('a').css('background-color', '#ff0000');
            newPagingHTML += next.html();
          }
        } else {
          newPagingHTML += sliderPagingTemplate.html();
        }
      }
      sliderPagingContainer.html(newPagingHTML);
    }
  }

  static showSlide(slideIndex) {
    console.log(`received show slide ${slideIndex}`);
    const allPagedSliders = Core6PagedSlider.getAllPagedSliders();

    const sliderCount = allPagedSliders.length;
    for (let i = 0; i < sliderCount; i += 1) {
      const thisSlide = $(allPagedSliders[i]);
      if (i === (slideIndex * 1)) {
        console.log(`show${i}`);
        thisSlide.show();
      } else {
        console.log(`hide${i}`);
        thisSlide.hide();
      }
    }
  }

  static nudgePagedSliderNext(e) {
    const elemA = $(e.currentTarget).parent()
      .parent()
      .parent()
      .parent()
      .parent();
    const elemB = elemA.next();

    if (elemA.hasClass('pagedsliderblock') && elemB.hasClass('pagedsliderblock')) {
      Core6Utilities.swapElement(elemA, elemB);
      Core6BlockDragger.saveBlockOrdering();
      Core6PagedSlider.showPagedSliderBlockNumbers();
    }
  }

  static nudgePagedSliderPrevious(e) {
    const elemA = $(e.currentTarget).parent()
      .parent()
      .parent()
      .parent()
      .parent();
    const elemB = elemA.prev();

    if (elemA.hasClass('pagedsliderblock') && elemB.hasClass('pagedsliderblock')) {
      Core6Utilities.swapElement(elemA, elemB);
      Core6BlockDragger.saveBlockOrdering();
      Core6PagedSlider.showPagedSliderBlockNumbers();
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6PagedSlider.js